// Splitter.tsx
import React, { type ReactNode, type CSSProperties } from "react";
import "./Splitter.css";

interface SplitterProps {
  children: ReactNode;
}

export const Splitter = ({ children }: SplitterProps) => {
  console.log("splitter");

  return <div className="splitter">{children}</div>;
};
